import React, { useContext, useEffect, useState, useMemo } from "react";
import "react-calendar/dist/Calendar.css";
import "../css/Solicitudes.css";
import CustomPagination from "../components/CustomPagination";
import { NewContext } from "../utils/ContextProvider";
import AgregarSolicitudModal from "../forms/Solicitud/AgregarSolicitudModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleLeft, faTrash, faPenToSquare, faFileArrowDown, faTriangleExclamation, faClipboard, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { getReason, getRequest, getRequestById, deleteRequestObject, getExportRequest, putAcceptRequest } from "../utils/peticionesApi";
import OptionComponentSolicitudes from "../components/OptionComponentSolicitudes";
import Button from "../components/Button";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Solicitudes = () => {
  const { getToken, getRol, getId, getAlert, getCompany } = useContext(NewContext);
  const [request, setRequest] = useState([]);
  const [reasons, setReason] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [menuVisible, setMenuVisible] = useState(false);
  const [showModalSolicitud, setShowModalSolicitud] = useState(false);
  const [modalDeleteSolicitud, setModalDeleteSolicitud] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [selectedSolicitud, setSelectedSolicitud] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (getToken && getId) {
      listarRequest();
    }
  }, [getToken, getId, showModalSolicitud]);

  useEffect(() => {
    listarReason();
  }, []);

  const closeMenu = () => setMenuVisible(false);
  const openModalSolicitud = () => {
    setSelectedSolicitud(null);
    setShowModalSolicitud(true);
  };

  const closeModalSolicitud = () => setShowModalSolicitud(false);

  const listarRequest = async () => {
    let response;
    try {
      if (id) {
        console.log(id);
        console.log(getRol);
        response = await getRequestById(id);
      } else if (getRol === "ROLE_ADMIN") {
        response = await getRequest();
      } else {
        response = await getRequestById(getId);
      }

      if (response && response.data) {
        setRequest(response.data);
      } else {
        getAlert({ msj: "Error: La respuesta no contiene datos.", tipe: "error" });
      }
    } catch (error) {
      if (error.response) {
        getAlert({ msj: `Error en la solicitud: ${error.response.status} - ${error.response.statusText}`, tipe: "error" });
      } else {
        getAlert({ msj: "Error al hacer la solicitud: " + error.message, tipe: "error" });
      }
    }
  };

  const formatDate = (dateArray) => {
    if (!Array.isArray(dateArray) || dateArray.length !== 3) {
      return "Fecha inválida";
    }

    const [year, month, day] = dateArray;
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  };

  const listarReason = async () => {
    try {
      const response = await getReason();
      setReason(response.data);
    } catch (error) {
      getAlert({ msj: "Error al listar motivos: " + error.message, tipe: "error" });
    }
  };

  const filtradoSolicitudes = useMemo(() => {
    return request?.filter((r) => {
      const searchLowerCase = searchTerm.toLowerCase();
      return (
        r.employee_first_name?.toLowerCase().includes(searchLowerCase) ||
        r.employee_last_name?.toLowerCase().includes(searchLowerCase) ||
        reasons.find(reason => reason.id === r.id_reason)?.reason?.toLowerCase().includes(searchLowerCase) ||
        formatDate(r.request_since).includes(searchLowerCase) ||
        r.observations_request?.toLowerCase().includes(searchLowerCase) ||
        (r.active ? "aprobado" : "pendiente").toLowerCase().includes(searchLowerCase)
      );
    });
  }, [searchTerm, request, reasons]);

  const solicitudesPorPagina = 15;
  const paginatedSolicitudes = useMemo(() => {
    const start = currentPage * solicitudesPorPagina;
    const end = start + solicitudesPorPagina;
    return filtradoSolicitudes.slice(start, end);
  }, [currentPage, filtradoSolicitudes]);

  const handleEditClick = (request) => {
    setSelectedSolicitud(request);
    setShowModalSolicitud(true);
  };

  const handleDeleteClick = (request) => {
    setSelectedRequestId(request.id_request);
    setModalDeleteSolicitud(true);
  };

  const handleHistorialClick = (request) => {
    navigate(`/solicitudHistorial/${request.id_request}/${request.uuid_employee}`);
  }

  const handleDeleteSolicitud = async () => {
    try {
      if (selectedRequestId) {
        await deleteRequestObject(selectedRequestId);
        getAlert({ msj: "Solicitud eliminada con éxito.", tipe: "succes" });
        setModalDeleteSolicitud(false);
        listarRequest();
      }
    } catch (error) {
      getAlert({ msj: "Error al eliminar la solicitud: " + error.message, tipe: "error" });
    }
  };

  const handleDownloadClick = async (request) => {
    setSelectedRequestId(request.id_request);

    try {
      await getExportRequest(request.id_request, getCompany);
      getAlert({ msj: "Exportación exitosa.", tipe: "succes" });
    } catch (error) {
      getAlert({ msj: "Error en la exportación: " + error.message, tipe: "error" });
    }
  };

  const handleFirmaClick = async (request) => {
    if (request.signed) {
        alert("Este documento ya ha sido firmado y no puede modificarse.");
        return;
    }

    if (request.uuid_employee !== getId) {
        alert("No puedes firmar este documento porque no te pertenece.");
        return;
    }

    try {
        console.log("Enviando firma con ID:", request.id_request, "y UUID:", request.uuid_employee);
        const response = await putAcceptRequest(request.id_request, getId, "Acepto, pero no estoy de acuerdo.");
        console.log("Sanción firmada con éxito:", response.data);
        alert("¡Has firmado la sanción correctamente!");
        listarRequest(); // ✅ Refrescar la tabla automáticamente
    } catch (error) {
        console.error("Error al firmar la sanción:", error);
        alert("Ocurrió un error al firmar la sanción.");
    }
};

const handleApplyFilters = () => {
  alert("En construccion");
}

  const TableRow = ({ request }) => {
    const motivo = reasons.find((reason) => reason.id === request.id_reason);
    const motivoName = motivo ? motivo.reason : "Motivo Desconocido";

    return (
      <tr>
        <td>{request.employee_first_name + " " + request.employee_last_name}</td>
        <td>{motivoName}</td>
        <td>{formatDate(request.request_since)}</td>
        <td>{request.observations_request}</td>
        <td>
          <span
            className={`itemActive ${request.status === "APROBADA"
              ? ""
              : request.status === "RECHAZADA"
                ? "itemInactive"
                : request.status === "OBSERVADA"
                  ? "itemObserved"
                  : "itemPending"
              }`}
          >
            {request.status === "APROBADA"
              ? "Aprobado"
              : request.status === "RECHAZADA"
                ? "Rechazado"
                : request.status === "OBSERVADA"
                  ? "Observado"
                  : "Pendiente"}
          </span>
        </td>

        <td className="contenedor-item">
          <FontAwesomeIcon icon={faPenToSquare} className="icon-edit" title="Editar solicitud" onClick={() => handleEditClick(request)} />
          <FontAwesomeIcon icon={faClipboard} className="icon-historial" title="Ver historial" onClick={() => handleHistorialClick(request)} />
          <FontAwesomeIcon
            icon={faFileSignature}
            className={`icon-firma ${request.signed || request.uuid_employee !== getId ? "icon-disabled" : ""}`}
            title={request.signed ? "Documento ya firmado" : request.uuid_employee !== getId ? "No puedes firmar este documento" : "Firmar documento"}
            onClick={() => request.signed || request.uuid_employee !== getId ? null : handleFirmaClick(request)}
            style={{
              cursor: request.signed || request.uuid_employee !== getId ? "not-allowed" : "pointer",
              opacity: request.signed || request.uuid_employee !== getId ? 0.5 : 1
            }}
          />
          <FontAwesomeIcon icon={faTrash} className="icon-salida" title="Eliminar solicitud" onClick={() => handleDeleteClick(request)} />
          <FontAwesomeIcon icon={faFileArrowDown} className="icon-File" title="Descargar archivo" onClick={() => handleDownloadClick(request)} />
        </td>
      </tr>
    );
  };

  const handleSubmitSolicitud = async (formData) => {
    try {
      if (formData.id_request) {
        console.log("Editando solicitud:", formData);
      } else {
        console.log("Agregando nueva solicitud:", formData);
      }

      listarRequest();
      setShowModalSolicitud(false);

    } catch (error) {
      console.error("Error al enviar la solicitud:", error);
    }
  };

  return (
    <div className="contenedor-solicitudes">
      {id && (
        <button
          onClick={() => window.history.back()}
          className="buttonVolverObj"
        >
          <FontAwesomeIcon icon={faCircleLeft} />
          Volver
        </button>
      )}
      <p className="titulo">
        {showModalSolicitud ? (selectedSolicitud ? "Modificar solicitud" : "Agregar solicitud") : "Solicitudes"}
      </p>
      {showModalSolicitud ? (
        <AgregarSolicitudModal
          reasons={reasons}
          rol={getRol}
          solicitud={selectedSolicitud}
          closeModalSolicitud={closeModalSolicitud}
          handleSubmitSolicitud={handleSubmitSolicitud}
        />
      ) : (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            <OptionComponentSolicitudes
              type="text"
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
              agregarFunction={openModalSolicitud}
              onApplyFilters={handleApplyFilters}
            />
          </div>
          <div className="data-table">
            <table>
              <thead>
                <tr>
                  <th>Solicitante</th>
                  <th>Motivo</th>
                  <th>Fecha</th>
                  <th style={{ width: "300px" }}>Observaciones</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {paginatedSolicitudes.length === 0 ? (
                  <tr>
                    <td colSpan="6">No se encontraron resultados.</td>
                  </tr>
                ) : (
                  paginatedSolicitudes.map((request, index) => (
                    <TableRow key={index} request={request} />
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-center mt-4">
            <div className="d-flex justify-content-center mt-4">
              <CustomPagination
                currentPage={currentPage}
                totalPages={Math.ceil(filtradoSolicitudes.length / solicitudesPorPagina)}
                setCurrentPage={setCurrentPage}
                hasNextPage={currentPage < Math.ceil(filtradoSolicitudes.length / solicitudesPorPagina) - 1}
              />
            </div>
          </div>
        </>
      )}

      {modalDeleteSolicitud && (
        <div className="modalDelete">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className="iconoDelete"
          />
          <p>¿Estas seguro de eliminar esta solicitud?</p>
          <div className="contenedorButonsDelete">
            <Button
              tipe="sinBg"
              msj="Cancelar"
              onClick={() => setModalDeleteSolicitud(!modalDeleteSolicitud)}
            />
            <Button msj="Confirmar" onClick={handleDeleteSolicitud} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Solicitudes;